import type { UseMutationResult } from 'react-query';
import { useMutation, useQueryClient } from 'react-query';

import type {
  IApiGetAppResponseBody,
  IApiUpdateAppRequestBody,
} from '../AppsApi.types';
import { useApi } from '~/lib/api/useApi';
import { appQueryKeyFactory } from './useAppQuery';
import { appsQueryKeyFactory } from './useAppsQuery';

export type IUseUpdateAppMutationValues = {
  appId: string;
  body: IApiUpdateAppRequestBody;
};

export const useUpdateAppMutation = (): UseMutationResult<
  IApiGetAppResponseBody,
  unknown,
  IUseUpdateAppMutationValues
> => {
  const api = useApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (values) => api.apps.update(values.appId, values.body),
    onSuccess: async (updatedApp) => {
      queryClient.setQueryData(
        appQueryKeyFactory({
          appId: updatedApp._id,
        })!,
        updatedApp,
      );
      await queryClient.invalidateQueries({
        queryKey: appsQueryKeyFactory(),
      });
    },
  });
};
